module.exports = __webpack_public_path__ + "media/images/city/031-british-museum-307dc55fe5ce4d6e8af965085e38b8c8.svg";